import { createContext } from "react";

import { useRequiredContext } from "~/tools/use-required-context";

import type { TimeRange } from "../../app/state/view/timeline/TimeRange";

export interface FormContextValue {
	timeRange: TimeRange;
}

const FormContext = createContext<FormContextValue | null>(null);

export const FormContextProvider = FormContext.Provider;

export function useFormTimeRange(): TimeRange {
	return useRequiredContext(FormContext, {
		providerName: "DrawerContent",
	}).timeRange;
}
